import { FC, useEffect, useMemo, useState } from "react";

import { Legend } from "../../../Charts/Legend/Legend";
import { LegendProps } from "../../../Charts/Legend/Legend.type";
import { LineChart } from "../../../Charts/LineChart/LineChart";
import { useBreakpoint } from "../../../../hooks/useBreakpoint";

import { EVOLUTION_OF_ENERGY_CONSUMPTION_AND_ENERGY_PRICES_CHART_DATA_KEYS } from "./EvolutionOfEnergyConsumptionAndEnergyPrices.const";
import { EvolutionOfEnergyConsumptionAndEnergyPricesLineChartToolTip } from "./tooltip/EvolutionOfEnergyConsumptionAndEnergyPricesLineChartToolTip";
import { EvolutionOfEnergyConsumptionAndEnergyPricesProps } from "./EvolutionOfEnergyConsumptionAndEnergyPrices.type";

const EvolutionOfEnergyConsumptionAndEnergyPrices: FC<EvolutionOfEnergyConsumptionAndEnergyPricesProps> = ({ lineChartData }) => {
	const chartSize = useBreakpoint();

	const [legendDirection, setLegendDirection] = useState<LegendProps["direction"]>("horizontal");

	const [chartData, setChartData] = useState(lineChartData);

	const [marginLeft, setMarginLeft] = useState(-20);
	const [axisFontSize, setAxisFontSize] = useState(14);
	const [xAxisPadding, setXAxisPadding] = useState(50);
	const [chartHeight, setChartHeight] = useState(350);

	const legendData = useMemo(() => {
		return EVOLUTION_OF_ENERGY_CONSUMPTION_AND_ENERGY_PRICES_CHART_DATA_KEYS.map((dataKey) => {
			const label = typeof dataKey?.translation === "string" ? dataKey.translation : dataKey.name;

			return {
				color: dataKey.color,
				label: label,
			};
		});
	}, []);

	useEffect(() => {
		switch (chartSize) {
			case "xs":
				//setChartData(lineChartData.filter((dataEntry) => ["2010", "2015", "2020"].includes(`${dataEntry.year}`)));
				setMarginLeft(0);
				setAxisFontSize(11);
				setXAxisPadding(20);
				setChartHeight(350);
				setLegendDirection("vertical");
				break;

			case "sm":
				//setChartData(lineChartData.filter((dataEntry) => ["2008", "2010", "2015", "2017", "2020"].includes(`${dataEntry.year}`)));
				setMarginLeft(0);
				setAxisFontSize(11);
				setXAxisPadding(15);
				setChartHeight(450);
				setLegendDirection("vertical");
				break;

			case "md":
			case "lg":
			case "xl":
				//setChartData(lineChartData.filter((_, i) => i % 2 === 0));
				setMarginLeft(0);
				setAxisFontSize(14);
				setXAxisPadding(20);
				setChartHeight(450);
				setLegendDirection("horizontal");
				break;

			default:
				setChartData(lineChartData);
				setMarginLeft(0);
				setAxisFontSize(14);
				setXAxisPadding(35);
				setChartHeight(450);
				setLegendDirection("horizontal");
				break;
		}
	}, [chartSize, lineChartData]);

	return (
		<div className="flex flex-col gap-8 mb-4">
			<LineChart
				YAxisLabel="Evolution of energy consumption and energy prices"
				yAxisLabelClassName="text-xl text-gray-800 font-bold"
				data={chartData}
				height={chartHeight}
				marginLeft={marginLeft}
				XAxisProps={{
					dataKey: "year",
					padding: { left: xAxisPadding, right: xAxisPadding },
					tick: { fontSize: axisFontSize },
				}}
				xDomain={[2010,2023]}
				customXTicks={[2010,2012,2014,2016,2018,2020,2022]}
				YAxisProps={{
					dataKey: "units",
					tickCount: 6,
					tick: { fontSize: axisFontSize },
					domain: [90, 140],
					interval: 0,
				}}
				dataKeys={EVOLUTION_OF_ENERGY_CONSUMPTION_AND_ENERGY_PRICES_CHART_DATA_KEYS}
				Tooltip={EvolutionOfEnergyConsumptionAndEnergyPricesLineChartToolTip}
				chartSubtitle="EU countries, indexed values (2010=100)"
			/>

			<div className="self-stretch md:self-center">
				<Legend items={legendData} direction={legendDirection} />
			</div>

		</div>
	);
};

export { EvolutionOfEnergyConsumptionAndEnergyPrices };
